import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import type {
    IMultiFilterModel,
    SetFilterModel,
    TextFilterModel,
} from 'ag-grid-community';
import type { CustomFloatingFilterProps } from 'ag-grid-react';
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

const startAdornment = (
    <InputAdornment position="start">
        <SearchIcon fontSize="small" sx={{ color: 'muiBlack' }} />
    </InputAdornment>
);
const StyTextField = styled(TextField, {
    name: 'StyTextField',
})({
    '& .MuiInputBase-input': {
        fontSize: '12px',
        // maxHeight and width are necessary with 'flexDirection: row' and 'alignItems: center' when floatingButton is enabled
        maxHeight: '30px',
        width: '100%', // On large columns, the input would not take the full width otherwise
    },
    '& .MuiOutlinedInput-adornedStart': {
        paddingLeft: '6px',
    },
    '& .MuiInputAdornment-positionStart': {
        marginRight: '4px',
    },
    flexDirection: 'row',
    alignItems: 'center',
});

const DEFAULT_MODEL: IMultiFilterModel = {
    filterType: 'multi',
    filterModels: [null, null],
};

// TODO: Use the vanilla AgGrid components when we'll use a newer AgGrid theme
/**
 * Cutom floating filter for the `agMultiColumnFilter` that allows filtering by text
 * and by set.
 */
const TextFloatingMultiFilter = ({
    model,
    onModelChange,
}: CustomFloatingFilterProps) => {
    const { t } = useTranslation();

    const onChange = ({
        target: { value: newValue },
    }: ChangeEvent<HTMLInputElement>) => {
        // whenever we change the 'text' filter, we reset the 'set' one. It may be possible to keep both,
        // but it looks tricky.
        onModelChange(
            newValue === ''
                ? DEFAULT_MODEL
                : {
                      filterType: 'multi',
                      filterModels: [
                          {
                              filterType: 'text',
                              type: 'contains',
                              filter: newValue,
                          },
                          null,
                      ],
                  },
        );
    };
    const value = model?.filterModels.find(
        (filter: TextFilterModel | SetFilterModel | null) =>
            filter?.filterType === 'text',
    )?.filter;
    return (
        <StyTextField
            value={value ?? ''}
            size="small"
            placeholder={t('common.searchPlaceholder')}
            InputProps={{
                startAdornment,
                disableInjectingGlobalStyles: true,
            }}
            onChange={onChange}
            variant="outlined"
        />
    );
};

export default TextFloatingMultiFilter;
